// Globals
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch } from '@/store';
import { updateDocumentsPrice } from '../../feature';

// Components
import { EditableInput } from '@/components';
import { Spinner } from '@/ui';
import { StyledContainer, StyledTitle } from '../../components';

// Helpers
import { renderCurrency } from '@/utils';
import { PricesFormValues } from '../../helpers';
import { useGetDocumentsPrice } from '../../hooks';

const DocumentPricesContainer = () => {
  const { t } = useTranslation('prices');
  const { isLoading, price } = useGetDocumentsPrice();
  const dispatch = useAppDispatch();

  const handleUpdate = async (data: Record<string, number>) => {
    try {
      await dispatch(
        updateDocumentsPrice({
          price: parseFloat(`${data[PricesFormValues.PRICE]}`),
        }),
      ).unwrap();
    } catch (error) {}
  };

  return (
    <StyledContainer>
      <StyledTitle>{t('title_documents')}</StyledTitle>
      <Spinner spinning={isLoading}>
        <EditableInput
          initialValues={{
            [PricesFormValues.PRICE]: price?.price ?? 0,
          }}
          name={PricesFormValues.PRICE}
          label={t('label_documents_price')}
          onChange={handleUpdate}
          type="number"
          text={renderCurrency(price?.price)}
          isLoading={isLoading}
        />
      </Spinner>
    </StyledContainer>
  );
};

export default DocumentPricesContainer;
